import { createApi } from "@reduxjs/toolkit/query/react";
import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import axios from "axios";
import { ILoginResponse } from "./auth/contracts";
import AsyncStorage from "@react-native-async-storage/async-storage";

const prodDomain: string = "https://m.biznesguard.ru";
const isProd: boolean = window.location.origin === prodDomain;
const url: string | undefined = isProd ? prodDomain : process.env.REACT_APP_API_BASE_URL || "https://m.biznesguard.ru";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: url,
  prepareHeaders: async (headers) => {
    const token: string | null = await AsyncStorage.getItem("token");

    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }

    headers.set("Content-Type", "application/json");

    return headers;
  },
});

export const baseQueryWithAuth: BaseQueryFn<
    FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (args.url?.includes("/auth/login") && result.data) {
    const responseData = result.data as ILoginResponse;

    if (responseData?.count === 1) {
      const token: string | undefined = responseData.users?.[0]?.token;

      if (token) {
        await AsyncStorage.setItem("token", token);
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      }
    }
  }

  if (result.error && args.url?.includes("/api/v1/users/auth/current_user/")) {
    await AsyncStorage.removeItem("token");
    delete axios.defaults.headers.common.Authorization;

    return { data: null };
  }

  return result;
};

export const api = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    "Auth",
    "Report",
    "Risk",
    "CreateReport",
    "CreateSupportMessage",
    "ReportPerson",
    "InsurancePolicy",
    "CurrentUser",
    "ReportHistory",
    "ResetPassword",
    "ConfirmResetPassword",
    "PersonalAgreement",
    "CreateAcceptance",
    "MonitoringChecking",
    "ShortMonitoringInfo",
    "FullMonitoringInfo",
    "CreateAcceptance",
    "UpdateReport",
    "GenerateReport",
    "DownloadReport"
  ],
  endpoints: () => ({}),
});
